import { Component, h, Method, Prop } from "@stencil/core";
import { TableDataColumnType } from "../interface";
import { TableDataCell } from "../table-data-cell/table-data-cell";
import { TableDataHeader } from "../table-data-header/table-data-header";

@Component({
    tag: "ux-table-data-column",
    styleUrl: "table-data-column.scss",
    shadow: false
})
export class TableDataColumn implements TableDataColumnType {
    /** defines which field of the table will be displayed in the column */
    @Prop() readonly field: string;
    /** defines the label of the table column */
    @Prop() readonly label: string;
    /** defines if the column should be a group */
    @Prop() readonly group: boolean = false;
    /** defines if the column should be sortable */
    @Prop() readonly sortable: boolean = false;
    /** defines the sort field name, if set, instead of using the column field */
    @Prop() readonly sortField?: string;
    /** wrap the content of this column if required, requires to set a max-width on table
     *  (e.g. using `full-width` or css prop `--ux-table-data-width`) or column */
    @Prop() readonly multiline: boolean = false;

    /** make the render function public */
    @Method()
    async getColumnMethods() {
        const { renderHeader, renderCell, getSortString } = this;
        return {
            renderHeader,
            renderCell,
            getSortString
        };
    }

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private getSortString = (row: any) => {
        const sortField = this.sortField || this.field;
        if (sortField === "" || !row[sortField]) {
            return "";
        }
        return row[sortField] + "";
    };

    private renderHeader = () => {
        return (
            <TableDataHeader
                label={this.label}
                sortable={this.sortable}
                sortField={this.sortField || this.field}
                group={this.group}
            />
        );
    };

    /** render the cell for the column */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private renderCell = (row: any) => {
        const { field, group, multiline } = this;
        const empty = field === "" || !row[field];
        return (
            <TableDataCell group={group} empty={empty} multiline={multiline}>
                <span>{!empty && row[field]}</span>
            </TableDataCell>
        );
    };
}
